module.exports = __webpack_public_path__ + "static/media/mtga-selector-color.b1910d49.png";